/** Renders the cost of an offer */

import React from 'react'
import { Map } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import classnames from 'classnames'

const Cost = ({ cost = Map(), passengerCount, children, selected }) =>
    <div className="col-wrapper-va">
        <div className="v-align">
            {children}
            <label className="price">
                <span>{cost.get('currency')} <em>{numeral(cost.get('amount')).format('0,0')}</em></span>
            </label>
            { passengerCount
                ? <span className="persons">For {passengerCount}</span>
                : null }
            <a className={classnames("btn btn-nx", {"btn-go":!selected, "btn-primary": selected})}>{selected ? `UNSELECT` : `SELECT`}</a>
        </div>
    </div>

Cost.propTypes = {
    cost: ImmutablePropTypes.map.isRequired,
    passengerCount: PropTypes.number,
    children: PropTypes.any
}

export default Cost



// WEBPACK FOOTER //
// ./src/ndc/offer/Cost.js